import Header from "../components/header";
import ClipPath from "../util/clippath";
import Scroller from "../util/scroller";
import ScrollTo from "../util/scrollto";
import objectFitImages from "object-fit-images";
import Carousels from "../components/carousel/index";
import ProductCarousels from "../components/products/index";
import ScrollViewport from "../util/scroll-viewport";

require("modernizr");

var LazyLoad = require("vanilla-lazyload");

export default {
    init() {
        var header = new Header(),
            detectie = require("detectie"),
            lazyload = new LazyLoad({ data_srcset: "srcSet" }),
            footer = "",
            newsletter_signup = "",
            scrollto = {
                elements: document.querySelectorAll(".scroll"),
                scroll: [],
            };

        new Carousels(".carousel");

        new ProductCarousels(".carousel--products");

        if (detectie() !== false) {
            document.documentElement.classList.add("ie");
        } else {
            document.documentElement.classList.add("no-ie");
        }

        if (ClipPath()) {
            document.documentElement.classList.add("clip-path");
        } else {
            document.documentElement.classList.add("no-clip-path");
        }

        setTimeout(() => {
            new ScrollViewport({
                className: ".scroll-trigger",
            });
        }, 500);

        function callback() {
            this.classList.add("is-visible");
        }

        // if (document.querySelector(".newsletter-signup")) {
        //     newsletter_signup = new Scroller(
        //         document.querySelector(".newsletter-signup"),
        //         {
        //             callback: callback,
        //             triggerOffset: -250,
        //             once: true,
        //         }
        //     );

        //     var form = document.querySelector(".newsletter-signup form");
        //     var alert = form.querySelector(".newsletter-signup__alert");

        //     form.addEventListener("submit", function (e) {
        //         e.preventDefault();

        //         var data = new FormData(form);
        //         var json = {};

        //         for (var entry of data.entries()) {
        //             json[entry[0]] = entry[1];
        //         }
        //         json = JSON.stringify(json);

        //         jQuery.ajax({
        //             type: "POST",
        //             url: form.getAttribute("action"),
        //             data: jQuery(form).serialize(),
        //             dataType: "jsonp",
        //             error: function (err) {
        //                 jQuery(alert)
        //                     .removeClass("success")
        //                     .addClass("bg-red error");
        //                 jQuery(alert).html("");
        //                 jQuery(alert).append(
        //                     "<i class='fa fa-thumbs-down'></i>"
        //                 );
        //                 jQuery(alert).append(
        //                     "<p>There was an error. Please try again.</p>"
        //                 );
        //             },
        //             success: function (data) {
        //                 if (data.result !== "error") {
        //                     jQuery(alert)
        //                         .removeClass("error")
        //                         .addClass("bg-green-2 success");
        //                     jQuery(alert).html("");
        //                     jQuery(alert).append(
        //                         "<i class='fa fa-thumbs-up'></i>"
        //                     );
        //                     jQuery(alert).append("<p>" + data.msg + "</p>");
        //                 } else {
        //                     jQuery(alert)
        //                         .removeClass("success")
        //                         .addClass("bg-red error");
        //                     jQuery(alert).html("");
        //                     jQuery(alert).append(
        //                         "<i class='fa fa-thumbs-down'></i>"
        //                     );
        //                     jQuery(alert).append("<p>" + data.msg + "</p>");
        //                 }
        //             },
        //         });
        //     });
        // }

        if (document.querySelector(".footer")) {
            footer = new Scroller(document.querySelector(".footer"), {
                trigger: "bottom",
                callback: callback,
                triggerOffset: -150,
                once: true,
            });
        }

        // if (document.querySelector(".floater")) {
        //     var head = document.head,
        //         link = document.createElement("link");

        //     link.type = "text/css";
        //     link.rel = "stylesheet";
        //     link.href = "/app/themes/rawhealth/dist/css/floats.css";

        //     head.appendChild(link);
        // }

        if (scrollto.elements.length > 0) {
            for (var i = 0; i < scrollto.elements.length; i++) {
                var target = document.querySelector(
                    scrollto.elements[i].getAttribute("data-target")
                );
                var offset = scrollto.elements[i].getAttribute("data-offset");

                // if (!offset) {
                //     offset = 0;
                // }

                scrollto.elements[i].addEventListener("click", function () {
                    ScrollTo(this.getAttribute("data-target"), -150);
                });
            }
        }
    },
    finalize() {
        objectFitImages();

        document.addEventListener("contentLoaded", function () {
            objectFitImages();
        });
    },
};



// WEBPACK FOOTER //
// ./js/routes/common.js